import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from 'ng2-translate';

import { NgbActiveModal, NgbModalRef, NgbDateStruct, NgbTimeStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Lesson } from './lesson.model';
import { LessonPopupService } from './lesson-popup.service';
import { LessonService } from './lesson.service';
import { School, SchoolService } from '../school';
import { ClassType, ClassTypeTypeaheadService } from '../class-type';
import { Student, StudentService, StudentTypeaheadService, StudentUtilService } from '../student';
import { Location, LocationService } from '../location';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';

import { SERVER_DATE_TIME_FORMAT } from '../../shared/constants/date-time.constants';
import { LESSONS_BULK_SAVE_WAIT_TIME_MILLIS } from '../../shared/constants/lesson.constants';
import { Principal, CRUD_ACTIONS } from '../../shared/index';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { map, switchMap } from 'rxjs/operators';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';

@Component({
    selector: 'jhi-lesson-bulk-create-dialog',
    templateUrl: './lesson-bulk-create-dialog.component.html'
})
export class LessonBulkCreateDialogComponent extends AbstractDialogComponent implements OnInit  {

    lesson: Lesson;
    lessonStartTime: NgbTimeStruct;
    lessonEndTime: NgbTimeStruct;

    fromDate: NgbDateStruct;
    fromMinDate: NgbDateStruct;
    toDate: NgbDateStruct;
    toMinDate: NgbDateStruct;
    toMaxDate: NgbDateStruct;
    createLessonsInUnavailableDays: boolean;
    bulkCreateParameters = {
        createInUnavailableDays: false,
        createInMondays: false,
        createInTuesdays: false,
        createInWednesdays: false,
        createInThursdays: false,
        createInFridays: false,
        createInSaturdays: false,
        createInSundays: false
    };

    authorities: any[];
    isSaving: boolean;

    classtypes: ClassType[];

    students: Student[];
    teachers: Student[];

    locations: Location[];

    // typeahead for the class type
    classTypeSearch = this.classTypeTypeaheadService.search;

    classTypeResultFormatter = this.classTypeTypeaheadService.resultFormatter;

    classTypeInputFormatter = (classType: any) => this.classTypeTypeaheadService
                                                      .inputFormatter(classType);

    constructor(
        public activeModal: NgbActiveModal,
        alertService: AlertService,
        private calendar: NgbCalendar,
        private lessonService: LessonService,
        schoolService: SchoolService,
        private locationService: LocationService,
        private studentUtilService: StudentUtilService,
        private studentService: StudentService,
        private eventManager: EventManager,
        private datePipe: DatePipe,
        private studentTypeaheadService: StudentTypeaheadService,
        private classTypeTypeaheadService: ClassTypeTypeaheadService,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
    }

    ngOnInit() {
        this.isSaving = false;
        this.createLessonsInUnavailableDays = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.fromMinDate =  { year: 2017, month: 1, day: 1 };

        // we force the lesson to not be videoConference when bulk create
        this.lesson.videoConference = false;

        this.schoolService.findCurrent().subscribe((res: School) => {
            this.currentSchool = res;
            if (!this.lesson.id) {
                this.lesson.maxParticipants = this.currentSchool.defaultLessonMaxParticipants;
                this.lesson.reservationCancellationPolicy = this.currentSchool.defaultLessonReservationCancellationPolicy;
                this.lesson.reminderPolicy = this.currentSchool.defaultLessonReminderPolicy;
            }
        }, (error: HttpErrorResponse) => {
            this.onError(error);
        });

        this.loadLocations();
        this.loadTeachersList();
        this.loadSchools();
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save(form: NgForm) {
        if (this.lesson.teacher instanceof Object && this.lesson.classType instanceof Object) {
            this.isSaving = true;

            let begining: Date = new Date();
            begining.setDate(this.fromDate.day);
            begining.setMonth(this.fromDate.month - 1);
            begining.setFullYear(this.fromDate.year);
            begining.setHours(this.lessonStartTime.hour);
            begining.setMinutes(this.lessonStartTime.minute);
            this.lesson.begining = this.datePipe
            .transform(begining, SERVER_DATE_TIME_FORMAT);

            let ending: Date = new Date();
            ending.setDate(this.fromDate.day);
            ending.setMonth(this.fromDate.month - 1 );
            ending.setFullYear(this.fromDate.year);
            ending.setHours(this.lessonEndTime.hour);
            ending.setMinutes(this.lessonEndTime.minute);
            this.lesson.ending = this.datePipe
            .transform(ending, SERVER_DATE_TIME_FORMAT);

            this.lesson.published = this.lessonService.getDefaultValueForPublished(this.lesson);
            this.lessonService.bulkCreate(this.lesson, this.toDate,
                this.bulkCreateParameters).delay(LESSONS_BULK_SAVE_WAIT_TIME_MILLIS)
                .subscribe((res: any) =>
                    this.onSaveSuccess(res, CRUD_ACTIONS.CREATE),
                    (res: HttpErrorResponse) => this.onSaveError(res));
        }  else if (!(this.lesson.classType instanceof Object)) {
            // clean the class type text field
            let classTypeInput = form !== undefined ? form.controls['classType'] : null;
            if (classTypeInput !== null) {
                classTypeInput.reset();
            }
        }
    }

    startTimeChanged(startTime: NgbTimeStruct) {
        if (!startTime) {
            return;
        }

        let start: Date = new Date();
        start.setHours(startTime.hour);
        start.setMinutes(startTime.minute);
        let end: Date = new Date();
        end.setHours(start.getHours() + 1);
        end.setMinutes(start.getMinutes() + 30);
        this.lessonEndTime = {
            hour : end.getHours(),
            minute : end.getMinutes(),
            second : 0
        };
    }

    fromDateChanged(fromDate: NgbDateStruct) {
        if (!fromDate) {
            return;
        }

        // We set the min date of the toCalendar to one day after the fromDate
        let minDate: Date = new Date(fromDate.year, fromDate.month - 1, fromDate.day + 1);
        this.toMinDate = {
            year: minDate.getFullYear(),
            month: minDate.getMonth() + 1,
            day: minDate.getDate()
        };

        // We set the max date of the toCalendar to 12 months from the fromDate
        let maxDate: Date = new Date(fromDate.year, fromDate.month - 1 + 12 , fromDate.day);
        this.toMaxDate = {
            year: maxDate.getFullYear(),
            month: maxDate.getMonth() + 1,
            day: maxDate.getDate()
        };

    }

    private onSaveSuccess(result: any, action: String) {
        // calculate next date to include the last date on the search
        const cur = new NgbDate(this.toDate.year, this.toDate.month, this.toDate.day);
        const next = this.calendar.getNext(cur, 'd', 1); // safely +1 day
        const newToDate: NgbDateStruct = { year: next.year, month: next.month, day: next.day };

        this.eventManager.broadcast({ name: 'lessonBulkCreation', content: {
            from: this.fromDate,
            to: newToDate
        }});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(httpErrorResponse: any) {
        this.isSaving = false;

        this.alertService.error(httpErrorResponse);
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }

    trackClassTypeById(index: number, item: ClassType) {
        return item.id;
    }

    trackStudentById(index: number, item: Student) {
        return item.id;
    }

    trackLocationById(index: number, item: Location) {
        return item.id;
    }

    getCalendar(): string {
        return 'Toussaints: 01/01/2018 - 05/01/2018,    Toussaints: 01/01/2018 - 05/01/2018,    Toussaints: 01/01/2018 - 05/01/2018';
    }

    private loadTeachersList() {
        this.studentService.queryTeachers()
        .subscribe(
            (res: HttpResponse<Student[]>) => {
                const teachersRaw = res.body;
                this.teachers = this.studentUtilService.orderStudentsByName(teachersRaw);
            },
            (res: HttpErrorResponse) => {
                this.onError(res);
            }
        );
    }

    private loadLocations() {
        this.locationService.search({query: 'active:true'})
            .subscribe(
            (res: HttpResponse<Location[]>) => {
                this.locations = res.body;
                if (!this.lesson.id && this.locations.length > 0) {
                    this.lesson.location = this.locations[0];
                }
            }, (res: HttpErrorResponse) => this.onError(res));
    }
}

@Component({
    selector: 'jhi-lesson-popup',
    template: ''
})
export class LessonBulkCreatePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private lessonPopupService: LessonPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.lessonPopupService
                    .open(LessonBulkCreateDialogComponent as Component, params['id']);
            } else {
                this.modalRef = this.lessonPopupService
                    .open(LessonBulkCreateDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson-bulk-create-dialog.component.ts